import React from "react";
import { WSPage } from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../query/WSQuery";
import { CollaboratorPayablesSummaryDashboard } from "./CollaboratorPayablesSummaryDashboard";
import { useHistory } from "react-router";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export const RouteCollaboratorPayablesSummaryReport: React.FC = () => {
  const history = useHistory();
  const qCollaboratorCustomFields =
    queriesCustomFields.listCustomFields.useQueryAll();
  const collaboratorCustomFields = (
    qCollaboratorCustomFields.flatData ?? []
  ).filter(
    customField => customField.resourceType === CustomFieldResourceType.PAYEE
  );

  return (
    <WSPage
      title="Contractor Payables Summary Report"
      breadcrumb={{
        label: "Back",
        onClick() {
          history.push("/member/reports");
        },
        icon: "arrow-left"
      }}
    >
      <WSQueries
        queries={{ collaboratorsAdditional: qCollaboratorCustomFields }}
      >
        {() => (
          <CollaboratorPayablesSummaryDashboard
            collaboratorsAdditionalData={collaboratorCustomFields}
          />
        )}
      </WSQueries>
    </WSPage>
  );
};
